/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationsListResponse, FetchApplicationsPayload } from './types';
import { apiClient } from '@/utils/apiClient';
import { toQS } from '@/utils/toQS';

export const fetchApplications = createAsyncThunk<
  ApplicationsListResponse,
  FetchApplicationsPayload | undefined,
  { rejectValue: string }
>('workflows/applications/fetch', async (payload, { rejectWithValue }) => {
  try {
    const qs = toQS(payload);
    const res = await apiClient(`/workflows/api/v1/applications/${qs}`, {
      method: 'GET',
    });
    return res as ApplicationsListResponse;
  } catch (err: any) {
    const r: any = err?.response ?? err;
    const msg =
      (Array.isArray(r?.error) && r.error.join(' ')) ||
      r?.error ||
      r?.message ||
      'Failed to load applications';
    return rejectWithValue(String(msg));
  }
});
